// import { onKeyDownCaption } from '@udecode/plate-caption';

import { createMyPluginFactory } from '../../plateFunctions';
import { ELEMENT_VIDEO_EMBED } from '../../plateTypes';
import { getValidVideoProvider } from './videoUtils';

export const createVideoEmbedPlugin = createMyPluginFactory({
  key: ELEMENT_VIDEO_EMBED,
  isElement: true,
  isVoid: true,
  deserializeHtml: {
    rules: [
      {
        validNodeName: 'IFRAME',
      },
    ],
    getNode: (el: HTMLElement) => {
      const url = el.getAttribute('src');
      const provider = getValidVideoProvider(url);
      if (provider) {
        return {
          type: ELEMENT_VIDEO_EMBED,
          url,
          provider: provider.provider,
          align: 'stretch',
        };
      }
    },
  },
});
